export default __webpack_public_path__ + "static/four-hands-6adfd028093cb397ca395d104f7363f1.svg";